var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "configuration-reference" }, [
        _c("div", { staticClass: "card-row row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Headline")
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.continues",
                        value: "required|max:80|min:10",
                        expression: "'required|max:80|min:10'",
                        modifiers: { continues: true }
                      }
                    ],
                    attrs: {
                      name: "headline",
                      maxlength: 80,
                      placeholder: "Add Headline"
                    },
                    on: {
                      input: function($event) {
                        _vm.headline = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.headline,
                      callback: function($$v) {
                        _vm.headline =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "headline"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("headline"),
                      expression: "errors.has('headline')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("headline")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Introduction")
                  ]),
                  _vm._v(" "),
                  _c("md-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.continues",
                        value: "required|max:250|min:100",
                        expression: "'required|max:250|min:100'",
                        modifiers: { continues: true }
                      }
                    ],
                    attrs: {
                      name: "introduction",
                      maxlength: 250,
                      placeholder: "Add Introduction",
                      rows: "2"
                    },
                    on: {
                      input: function($event) {
                        _vm.introduction = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.introduction,
                      callback: function($$v) {
                        _vm.introduction =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "introduction"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("introduction"),
                      expression: "errors.has('introduction')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("introduction")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Content")
                  ]),
                  _vm._v(" "),
                  _c("md-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.continues",
                        value: "required|max:2000|min:250",
                        expression: "'required|max:2000|min:250'",
                        modifiers: { continues: true }
                      }
                    ],
                    attrs: {
                      name: "content",
                      maxlength: 2000,
                      placeholder: "Add Content",
                      rows: "2"
                    },
                    on: {
                      input: function($event) {
                        _vm.content = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.content,
                      callback: function($$v) {
                        _vm.content = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "content"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("content"),
                      expression: "errors.has('content')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("content")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Close")
                  ]),
                  _vm._v(" "),
                  _c("md-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.continues",
                        value: "required|max:250|min:5",
                        expression: "'required|max:250|min:5'",
                        modifiers: { continues: true }
                      }
                    ],
                    attrs: {
                      name: "close",
                      maxlength: 250,
                      placeholder: "Add Close",
                      rows: "2"
                    },
                    on: {
                      input: function($event) {
                        _vm.close = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.close,
                      callback: function($$v) {
                        _vm.close = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "close"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("close"),
                      expression: "errors.has('close')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("close")))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.saveOwner()
                    }
                  }
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h2", { staticClass: "match-header" }, [_vm._v("Add Wizard Content")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72364c6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72364c6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationWizardContentAdd.vue
// module id = null
// module chunks = 